import React from 'react';
import './BookendSection.scss';
import Slider from "react-slick";
import { Button, Row, Col, Layout } from 'antd';
import { PORTAL_BASE_URL, REGISTER_POSTHOG_API_KEY, POSTHOG_API_HOST } from '../../../env';
import posthog from 'posthog-js';

const { Content } = Layout;
// ... (slider_images and slider_images_2 remain the same)
const slider_images = [
  '/smb/slider/slider (13).jpg',
  '/smb/slider/slider (1).jpeg',
  '/smb/slider/slider (16).png',
  '/smb/slider/slider (2).jpg',
  '/smb/slider/slider (6).jpg',
  '/smb/slider/slider (15).jpg',
  '/smb/slider/slider (5).jpg',
  '/smb/slider/slider (12).jpg',

]

const slider_images_2 = [
  '/smb/slider/slider (3).jpg',
  '/smb/slider/slider (10).jpg',
  '/smb/slider/slider (4).jpg',
  '/smb/slider/slider (11).jpg',
  '/smb/slider/slider (14).jpg',
  '/smb/slider/slider (7).jpg',
  '/smb/slider/slider (8).jpg',
  '/smb/slider/slider (9).jpg'
]


const BookendSection = () => {
  return (
    <>
      <WebVersion />
      <MobileVersion />
    </>
  );
};

const WebVersion = () => {
  const settings = {
    autoplay: true,
    dots: false,
    infinite: true,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    vertical: true,
    speed: 6000,
    autoplaySpeed: 6000,
    cssEase: "linear",
    pauseOnHover: false,
  };

  const settings_2 = {
    autoplay: true,
    dots: false,
    infinite: true,
    slidesToShow: 1.5,
    slidesToScroll: -1,
    vertical: true,
    speed: 6000,
    autoplaySpeed: 6000,
    cssEase: "linear",
    pauseOnHover: false,
  };
  const utm_source = localStorage.getItem('utm_source') || null;
  const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=smb_3d_services&utm_source=${utm_source}`;


  return (<Content className="d-none d-lg-block">
    <Row className="container-fluid justify-space-between bookend-section" style={{ minHeight: '600px' }}>
      <Col span={11} className='justify-in-start direction-flex' style={{ padding: 0, display: 'flex' }}>
        <img className='img-styles' src='/smb/Slider.png' />
      </Col>
      <Col span={13} className="section-text">
        <h3 className='manrope f-50 w-600 black-085 lh-58 mb-16'>Join the future of ecommerce</h3>

        <p className='manrope f-16 w-500 black-085 lh-24 mb-32'>Try the ALL3D platform for free to start your switch to 3D.</p>

        <div className="justify-in-start">
          <Button onClick={() => {
            const urlParams = new URLSearchParams(window.location.search);
            const email = urlParams.get('email') || "";
            const ph = posthog.init(REGISTER_POSTHOG_API_KEY, {
              api_host: POSTHOG_API_HOST,
              autocapture: false,
              name: "register",
              capture_pageview: false,
              loaded: (ph) => {
                if (utm_source) ph.register({ utm_source: utm_source });
              },
            });
            if (ph) {
              ph.capture('free_trial_click', {
                location: window.location.pathname,
                utm_source: utm_source,
                button: 'get_started_for_free',
                email: email
              });
            }
            window.open(`${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(redirectPath)}`, "_blank")
          }}
            className={`manrope f-16 w-700 lh-24 blue-button`}>
            Get started for free
          </Button>
          <Button onClick={() => {
            window.location.href = '/pricing'
          }}
            className={`manrope f-16 w-700 lh-24 white-button-black-border ml-16`}
          >
            View pricing & plans
          </Button>
        </div>
      </Col>
    </Row>
  </Content>
  );
};


const MobileVersion = () => {
  const settings = {
    autoplay: true,
    dots: false,
    infinite: true,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    vertical: true,
    speed: 6000,
    autoplaySpeed: 6000,
    cssEase: "linear",
    pauseOnHover: false
  };


  const settings_2 = {
    autoplay: true,
    dots: false,
    infinite: true,
    slidesToShow: 1.5,
    slidesToScroll: -1,
    vertical: true,
    speed: 6000,
    autoplaySpeed: 6000,
    cssEase: "linear",
    pauseOnHover: false
  };
  const utm_source = localStorage.getItem('utm_source') || null;
  const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=smb_3d_services&utm_source=${utm_source}`;


  return (<Content className="d-lg-none">
    <Row className="container-fluid bookend-section-mobile">
      <Col span={24}>
        <h1 className="manrope f-38 w-600 black-085 lh-46 mb-16 text-left">
          Join the future of ecommerce
        </h1>
        <h5 className="manrope f-16 w-500 black-085 lh-24 mb-24 text-left">
          Try the ALL3D platform for free to start your switch to 3D.
        </h5>

      </Col>
      <Col span={24} className="justify-in-center direction-flex height-max-c mb-24" style={{ padding: 0 }}>
        <img className='img-styles' src='/smb/Slider.png' />
      </Col>
      <Col span={24}>
        <Button onClick={() => {
          const urlParams = new URLSearchParams(window.location.search);
          const email = urlParams.get('email') || "";
          const ph = posthog.init(REGISTER_POSTHOG_API_KEY, {
            api_host: POSTHOG_API_HOST,
            autocapture: false,
            name: "register",
            capture_pageview: false,
            loaded: (ph) => {
              if (utm_source) ph.register({ utm_source: utm_source });
            },
          });
          if (ph) {
            ph.capture('free_trial_click', {
              location: window.location.pathname,
              utm_source: utm_source,
              button: 'get_started_for_free',
              email: email
            });
          }
          window.open(`${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(redirectPath)}`, "_blank")
        }}
          className={`manrope f-16 w-700 lh-24 blue-button w-100 centerCarousel mb-16`}
          block>
          Get started for free
        </Button>
        <Button onClick={() => {
          window.location.href = '/pricing'
        }}
          className={`manrope f-16 w-700 lh-24 w-100 white-button-black-border centerCarousel`}
          block>
          View pricing & plans
        </Button>
      </Col>
    </Row>
  </Content>)
}
export default BookendSection;
